import React, { useState } from "react";

const FilesAttachments = () => {
  const [showModal, setShowModal] = useState(false);

  const handleViewClick = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
      <h2 className="text-lg font-medium mb-4 underline text-[#333333]">Files Attachment</h2>
      <table>
        <tbody>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Other Files Relevant to your Business Promotion:
            </td>
            <td className="p-3 text-sm text-blue-600 cursor-pointer underline" onClick={handleViewClick}>
              View
            </td>
          </tr>
        </tbody>
      </table>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-fit max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Attached Files</h3>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="grid grid-cols-1 gap-4">
           <img
                 src="https://picsum.photos/seed/image2/400/250"
                alt="Attachment 1"
                className="w-full h-auto rounded shadow"
              />  
             
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="bg-[#0099E5] hover:bg-[#007FCC] text-white px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilesAttachments;
